import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import AuthState from "storeState/auth";
import _ from 'lodash';
import { selectors as uiSelectors } from 'storeState/ui';

import Input from 'components/views/input/Input';
import Button  from 'components/views/button/Button';
import URLService from "service/URLService";
import authStore from 'storeState/auth';

import './login.scss';
import {actionMeta} from "../../../storeState/auth/meta";

class Login extends Component {

    static contextTypes = {
        intl: PropTypes.object
    }

    constructor(props){
        super(props);

        this.state={
          tenant: "",
          email: "",
          password: "",
          loginError: null,
        };

    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if(!_.equals(nextProps.loginResponse, this.props.loginResponse)){
            if(nextProps.loginResponse && nextProps.loginResponse.response){
               if(nextProps.loginResponse.response.status == 200){

               }else{
                   this.setState({
                       loginError: nextProps.loginResponse.response.status
                   })
               }
            }
        }
    }

    handleTenantChange = (ev) => {
      this.setState({
        tenant: ev.target.value
      })
    }

    handleEmailChange = (ev) => {
        this.setState({
            email: ev.target.value
        })
    }

    handlePasswordChange = (ev) => {
        this.setState({
            password: ev.target.value
        })
    }

    handleLoginButtonClick = () => {
        this.props.actions.loginRequest({
            "email": this.state.email,
            "password": this.state.password,
            "tenant": this.state.tenant
        })
    }

    hasErrors = () => {
        return false;
    }

    render() {

        const {formatMessage} = this.context.intl;

        return (
            <div className="login-container">
                <img className="actidoo-logo" src={require("assets/images/actidoo-a.png")} />
                <h2><FormattedMessage id="login.heading" defaultMessage="Welcome"/></h2>
                <Input
                  className="login-tenant"
                  type="text"
                  title={formatMessage({id: "login.tenant.title", defaultMessage: "Tenant"})}
                  placeholder={formatMessage({id: "login.tenant.placeholder", defaultMessage: "e.g. company.com"})}
                  value={this.state.tenant}
                  onChange={this.handleTenantChange}
                  centeredBlock={true}
                />
                <div className="spacer"></div>
                <Input
                    className="login-email"
                    type="email"
                    title={formatMessage({id: "login.email.title", defaultMessage: "E-Mail-Adress"})}
                    placeholder={formatMessage({id: "login.email.placeholder", defaultMessage: "demo@actidoo.com"})}
                    value={this.state.email}
                    onChange={this.handleEmailChange}
                    centeredBlock={true}
                />
                <div className="spacer"></div>
                <Input
                    className="login-password"
                    type="password"
                    title={formatMessage({id: "login.password.title", defaultMessage: "Password"})}
                    placeholder={formatMessage({id: "login.password.placeholder", defaultMessage: "********"})}
                    value={this.state.password}
                    onChange={this.handlePasswordChange}
                    centeredBlock={true}
                />
                <If condition={this.state.loginError}>
                    <div className="error">{formatMessage({id: "login.error.message", defaultMessage: "Invalid Login"})}</div>
                </If>
                <Button
                    className="login-button-submit"
                    onClick={this.handleLoginButtonClick}
                    disabled={this.hasErrors()}
                    centeredBlock={true}>
                    <FormattedMessage id="login_label_submit" defaultMessage="Login" />
                </Button>

                {/*<Button className="login-button-register" toInternal={"/auth/registration"} centeredBlock={true}>
                    <FormattedMessage id="login.registration.link" defaultMessage="Create a new account"/>
                </Button>*/}

            </div>
        );
    }
}

export default connect((state, props) => {
    return {
        loginResponse: AuthState.selectors.getResponse(state, {id: AuthState.constants.LOGIN_RESPONSE})
    }
},(dispatch, props) => {
    return {
        actions: bindActionCreators(Object.assign({}, authStore.actions), dispatch)
    }
})(Login)



// WEBPACK FOOTER //
// ./src/components/views/login/Login.js